import React, { useEffect, Suspense } from "react"
import { View, Router, NotFoundBoundary } from "react-navi"
import { initializeThunk } from "./../store/thunks/startupThunks"
import MainLayout from "../components/layouts/MainLayout"
import { navigationService } from "../services/navigationService"
import { INavigationContext } from "./INavigationContext"
import NotFoundPage from "../pages/NotFoundPage"
import { mainRoutes } from "./mainRoutes"
import useReduxDispatch from "../store/useReduxDispatch"

interface IProps {}

const MainRouter = ({}: IProps) => {
    const dispatch = useReduxDispatch()

    useEffect(() => {
        dispatch(initializeThunk())
    }, [])

    const navigationContext: INavigationContext = {}
    const navigation = navigationService.setup(navigationContext, mainRoutes)
    return (
        <Router navigation={navigation} context={navigationContext}>
            <MainLayout>
                <NotFoundBoundary render={() => <NotFoundPage />}>
                    <Suspense fallback={null}>
                        <View />
                    </Suspense>
                </NotFoundBoundary>
            </MainLayout>
        </Router>
    )
}

export default MainRouter
